import React from "react";
import dynamic from "next/dynamic";
import Text from "@/bit/components/components.text";
import Button from "@/bit/components/components.button";
import DetailCardTitle from "@/bit/components/components.cms-block.cms-detail-card-title";
import Alert from "@/bit/components/components.cms-block.cms-alert";

const CmsEditableGroupIcons = dynamic(
  () => import("@/bit/components/components.cms-block.cms-editable-group-icons")
);

const NOTICE_TAGGING_INFO = {
  componentName: "nps-enlace",
  componentVariation: "all",
};

const NoticeBlock = (props) => {
  const {
    "cms-ml-detail-card-title-1": noticeTitle,
    "cms-atom-text-1": noticeText,
    "cms-atom-button-1": noticeButton1,
    "cms-atom-button-2": noticeButton2,
    "cms-atom-button-3": noticeButton3,
    "cms-ml-alert-1": noticeAlert,
    "cms-hiring-details-1": hiringDetails,
    loadedContent,
    flags,
    cmsHandler,
    alias,
    frontalListToDelete,
    blockName,
    index,
  } = props;

  let taggingButton1 = {}
  let taggingButton2 = {}
  let taggingButton3 = {}

  if (noticeButton1) {
    taggingButton1 = {
      ...NOTICE_TAGGING_INFO,
      componentContent: noticeButton1.label || "Lo quiero",
      ...noticeButton1.taggingInfo,
      componentVariation: flags || "",
    };
  }

  if (noticeButton2) {
    taggingButton2 = {
      ...NOTICE_TAGGING_INFO,
      componentContent: noticeButton2.label || "Lo quiero",
      ...noticeButton2.taggingInfo,
      componentVariation: flags || "",
    };
  }

  if (noticeButton3) {
    taggingButton3 = {
      ...NOTICE_TAGGING_INFO,
      componentContent: noticeButton3.label || "Lo quiero",
      ...noticeButton3.taggingInfo,
      componentVariation: flags || "",
    };
  }

  return (
    <div
      className={`notice-block-item${loadedContent ? "" : " skeleton"}${
        cmsHandler ? " edit-mode" : ""
      }`}
    >
      {/* Bolitas de edicion aqui */}
      <CmsEditableGroupIcons
        elementProps={{
          ...props,
          hiringDetails,
          editName: "cms-block.cms-notice-block",
        }}
        deleteProps={{
          index,
          itemIdDotNotation: `${blockName}.notice-block-list-1`,
          alias,
          frontalListToDelete,
        }}
        visibleTools={{
          hiring: true,
          edit: false,
          deleteItem: true,
        }}
        noCustomLink
        cmsHandler={cmsHandler}
      />
      {noticeTitle && (
        <DetailCardTitle
          detailCardTitleProps={noticeTitle}
          cmsHandler={cmsHandler}
        />
      )}
      {noticeText && <Text {...noticeText} cmsHandler={cmsHandler} />}
      {noticeAlert && <Alert {...noticeAlert} cmsHandler={cmsHandler} />}
      {(cmsHandler ||
        noticeButton1?.label ||
        noticeButton2?.label ||
        noticeButton3?.label) && (
        <div className="notice-block-item--buttons">
          <Button {...noticeButton1} taggingInfo={taggingButton1} cmsHandler={cmsHandler} />
          <Button {...noticeButton2} taggingInfo={taggingButton2} cmsHandler={cmsHandler} />
          <Button {...noticeButton3} taggingInfo={taggingButton3} cmsHandler={cmsHandler} />
        </div>
      )}
      <style jsx>{`.notice-block-item {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid #dddddd;
  &.edit-mode {
    padding-top: 2rem;
  }
  &--buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    :global(.buttonx) {
      position: relative !important;
    }
  }
}

@media (min-width: 768px) {
  .notice-block-item--title {
    align-items: center;
  }
}
`}</style>
    </div>
  );
};

export default NoticeBlock;
